import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ff7a69b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pb-100" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title mw-600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "top-title" }, "Our Celebrities"),
  /*#__PURE__*/_createElementVNode("h2", null, "Exclusively shining with us — only on MyCelebrity.")
], -1))
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-4" }
const _hoisted_6 = { class: "testimonial-img position-relative mb-4 mb-lg-0 d-inline-block" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "testimonial-quot" }
const _hoisted_10 = { class: "testimonial-info ms-0 text-start" }
const _hoisted_11 = { ZZ: "" }
const _hoisted_12 = { class: "button-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_swiper, {
        spaceBetween: 25,
        slidesPerView: 1,
        preventClicks: true,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: '.next',
          prevEl: '.prev',
        },
        modules: _ctx.modules,
        class: "testimonial-slide testimonials-wrappers"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              key: testimonial.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        title: "celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore",
                        src: testimonial.image,
                        alt: "testimonials"
                      }, null, 8, _hoisted_7)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("p", null, _toDisplayString(testimonial.description), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("h3", _hoisted_11, _toDisplayString(testimonial.name), 1),
                        _createElementVNode("span", null, _toDisplayString(testimonial.designation), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: "/get-your-wish",
        class: "btn btn-primary get-wish-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Get your Wish ")
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/business-enquiry",
        class: "btn btn-primary get-wish-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Business Enquiry ")
        ]),
        _: 1
      })
    ])
  ]))
}